<template>
  <div class="container-listagem-anexos">
    <br/>
    <br/>
    <TrfSimpleTable 
        :configuracaoDeColunas="configuracaoDeColunas"
        :dados="listagemDados"
        :isCliente=false
        mensagemSemDados="Não há anexos adicionados"
        :isSelectable="false"
        :hasSlotLine="false"
        :isToggleble="false"
        :isMultipleSelection="false">
        <template #tamanho="{item}">
          {{ tamanhoFormatado(item) }}
        </template>

        <template #acoes="{item, index}">
          <div class="buttons is-pulled-right">
            <button
              v-if="acoes.includes('visualizar')"
              v-e2e="`btn-visualizar-anexo-${index}`"
              class="button ml-1"
              :class="{'is-disabled': !isExtensaoVisualizavelNoNavegador(item)}"
              :title="isExtensaoVisualizavelNoNavegador(item) ? 'Visualizar' : 'Arquivo não pode ser visualizado'"
              type="button"
              :disabled="!isExtensaoVisualizavelNoNavegador(item)"
              @click.prevent="() => visualizarAnexo(item)"
            >
              <span class="icon">
                <i class="mdi mdi-eye mdi-18px" aria-hidden="true"></i>
              </span>
            </button>
            
            <button
              v-if="acoes.includes('download')"
              v-e2e="`btn-download-anexo-${index}`"
              class="button ml-1"
              title="Download"
              type="button"
              @click.prevent="() => downloadAnexo(item)"
            >
              <span class="icon">
                <i class="mdi mdi-download mdi-18px" aria-hidden="true"></i>
              </span>
            </button>

            <button
              v-if="acoes.includes('excluir')"
              v-e2e="`btn-excluir-${index}`"
              data-label="btn-excluir-anexo"
              class="button ml-1"
              title="Remover anexo"
              type="button"
              :disabled="preview"
              @click.prevent="() => removerAnexo(item, index)"
            >
              <span class="icon">
                <i class="mdi mdi-delete mdi-18px" aria-hidden="true"></i>
              </span>
            </button>
          </div>
        </template>
    </TrfSimpleTable>
  </div>
</template>
    <script>
    import { defineAsyncComponent } from 'vue';
    import { fileUtils } from '../../../../util/file.utils';
    
    export default {
      name: 'TrfListagemDeAnexosCadastro',
      emits: ['elegalize-remover-anexo', 'elegalize-visualizar-anexo', 'elegalize-download-anexo'],
      components: {
        TrfSimpleTable: defineAsyncComponent(() => import('../../../../components/SimpleTable/index.vue')),
      },
      props: {
        listagemDeAnexos: {
            type: Array,
            default: new Array(),
            required: false
        },
        acoes: {
          type: Array,
          default: () => ['excluir']
        },
        preview: {
          type: Boolean,
          default: false
        },

      },
      data() {
        return {
          formData: [],
          configuracaoDeColunas: [
                {
                titulo: "Nome",
                nome: "nome",
                referencia: ['nome'],
                divisor: ""
                },
                {
                titulo: "Extensão",
                nome: "extensao",
                referencia: ['extensao'],
                divisor: ``
                },
                {
                titulo: "Tamanho",
                nome: "tamanho",
                referencia: ['tamanho'],
                divisor: ``,
                slot: true
                },
                {
                titulo: "",
                nome: 'acoes',
                referencia: ['acoes'],
                divisor: "",
                slot: true
                }
            ]
        };
      },
      computed: {
        listagemDados() {
            return this.listagemDeAnexos
        }
      },
      methods: {
        async removerAnexo(item, index) {
          this.$emit('elegalize-remover-anexo', index);
        },
        tamanhoFormatado(item) {
          return `${fileUtils._convertebyteParaMb(item.size).toFixed(3)} MB`
        },
        isExtensaoVisualizavelNoNavegador(item) {
          const extensao = item.extensao;
          return fileUtils.isExtensaoVisualizavelNoNavegador(extensao);
        },
        visualizarAnexo(anexo) {
          if (!this.isExtensaoVisualizavelNoNavegador(anexo)) return;
          this.$emit('elegalize-visualizar-anexo', anexo);
        },
        downloadAnexo(anexo) {
          this.$emit('elegalize-download-anexo', anexo);
        }
      },
      mounted() {
      }
    };
    </script>
    <style lang="scss" scoped>
    .multiselect-econtador {
      margin: 0;
    }
    </style>
    